goog.provide("shadow.js.shim.module$src$svg$controls$zoom_svg$default");
shadow.js.shim.module$src$svg$controls$zoom_svg$default = shadow.js.shim.module$src$svg$controls$zoom_svg.default;
